import { useState } from 'react';
import { useParams } from 'react-router-dom';

import Tooltip from '@mui/material/Tooltip';

import Dictation from '@webclient/components/search-forms/gamification-search/actions/mic/dictation';

import useAppDispatch from '@webclient/hooks/useAppDispatch';
import useAppSelector from '@webclient/hooks/useAppSelector';

import searchAsyncOrchestrator from '@webclient/state/slices/search-session/thunks/searchAsyncOrchestrator';
import { startDictation } from '@webclient/state/slices/search-widget-dictation';

import MicRoundedIcon from '~icons/knowz-iconify/mic';

import { IconButton } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';

export default function Mic() {
  const dispatch = useAppDispatch();
  const { t } = useTranslate();
  const params = useParams<{ id?: string }>();
  const threadIdFromParams = params.id;
  const [isPending, setIsPending] = useState(false);
  const isDictationOn = useAppSelector(
    (state) => state.searchWidgetDictation.isDictationOn,
  );

  async function handleStartDictation() {
    setIsPending(true);
    await dispatch(
      searchAsyncOrchestrator(
        threadIdFromParams
          ? {
              requestOrigin: 'search',
              searchThreadId: threadIdFromParams,
              withAudio: true,
            }
          : {
              requestOrigin: 'home',
              withAudio: true,
            },
      ),
    ).finally(() => {
      setIsPending(false);
    });
    dispatch(startDictation());
  }

  if (isDictationOn) return <Dictation />;

  return (
    <Tooltip
      title={t('layout.searchWidget.dictation.on', 'Turn on live dictation')}
      arrow
      placement="top"
    >
      <IconButton
        onClick={handleStartDictation}
        disabled={isPending}
        variant="ghost"
        color="secondary"
        size="small"
      >
        <MicRoundedIcon />
      </IconButton>
    </Tooltip>
  );
}
